export const INSIGHTS_LABELS = {
  defaultTitle: 'Lema AI insights',
  details: 'Details',
} as const
